// import { Domains } from "~/shared/constants";
import { ThemeType } from "~/shared/enum"

export const useTheme = () => {
    let cookieThemeType = localStorage.getItem('theme') as ThemeType || ThemeType.SAMPLE2;
    // const domain = window.location.host.replaceAll('www.', '');
    // const index = Domains.findIndex(x => x.domains.includes(domain));
    // if(index < 0) {
    //     cookieThemeType = (localStorage.getItem('theme') as ThemeType) || ThemeType.SAMPLE2;
    // } else {
    //     cookieThemeType = Domains[index].theme;
    // }

    const setThemeType = (type: ThemeType) => {
        localStorage.setItem('theme', 'sample5');
    }

    return { cookieThemeType, setThemeType }
}